module.exports = __webpack_public_path__ + "static/media/BM_Locations.3ab4451d.svg";